import { useMediaQuery } from 'usehooks-ts';

export const useIsMobile = (): boolean => useMediaQuery('(max-width: 768px)');
